import styled from 'styled-components';

export const MarkdownContentStyle = styled.div`
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.6;
  color: ${(props) => props.theme.colors.gray700};
  font-family: 'Instrument Sans', 'Pretendard';
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${(props) => props.theme.colors.gray800};
    font-weight: 600;
    margin-bottom: 0.4em;
    margin-top: 0.4em;
  }
  h1 {
    font-size: 2em;
  }
  h2 {
    font-size: 1.15em;
  }
  h3 {
    font-size: 1em;
  }
  h4 {
    font-size: 1em;
  }
  h5 {
    font-size: 0.875em;
  }
  h6 {
    font-size: 0.75em;
  }

  p {
    margin: 0;
  }
  ol,
  ul {
    padding-left: 0;
    margin: 0;
  }
  ul {
    list-style: none;
    li {
      margin-bottom: 4px;
      line-height: 1.6;
    }
    li::before {
      font-size: 16px;
      content: '•';
      margin-right: 4px;
      margin-left: -10px;
      color: ${(props) => props.theme.colors.gray700};
      flex-shrink: 0;
    }
  }
  ol {
    list-style: decimal;
    margin-left: 2px;
  }
  li {
    margin-bottom: 8px;
    margin-left: 12px;
  }

  li:last-child {
    margin-bottom: 0;
  }

  hr {
    margin: 20px 0;
  }

  hr:first-child {
    margin-top: 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray300};
    border-top: 1px solid ${(props) => props.theme.colors.gray300};
    margin: 12px 0;
    font-size: 13px;
  }
  th,
  td {
    border-bottom: 1px solid ${(props) => props.theme.colors.gray300};
    border-top: 1px solid ${(props) => props.theme.colors.gray300};
    padding: 8px;
    text-align: left;
  }
  th {
    background-color: ${(props) => props.theme.colors.gray150};
    font-weight: 600;
    color: ${(props) => props.theme.colors.gray700};
  }

  blockquote {
    font-size: 13px;
    padding: 8px 12px;
    background-color: ${(props) => props.theme.colors.gray200};
    border-radius: 6px;
    margin: 12px 0;
    li {
      margin-bottom: 2px;
    }
  }

  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
    white-space: nowrap;
  }

  code {
    font-family: monospace;
    font-weight: 400;
    font-size: 12px;
    padding: 1px 2px;
    background-color: ${(props) => props.theme.colors.gray200};
    border: 1px solid ${(props) => props.theme.colors.gray400};
    border-radius: 2px;
    color: ${(props) => props.theme.colors.red600};
  }
`;
